var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.961H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V68.4275H0V-0.00585938ZM0 136.761H513V205.194H0V136.761ZM0 273.628H513V342.061H0V273.628Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.028L0 341.961V-0.00585938L256.5 171.028Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6689 111.612L99.3937 150.888H140.774L107.309 175.136L120.134 214.512L86.6689 190.265L53.2037 214.512L66.0287 175.136L32.5635 150.888H73.8439L86.6689 111.612Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCu);
export default __webpack_public_path__ + "static/media/CU.e66288798cd3888a5d51b48e0cb96456.svg";
export { ForwardRef as ReactComponent };